import React from 'react'
import {
  calculateDaysOverdue,
  formatDaysAgo,
  formatDateToBrazilian,
} from '../../../../../../_metronic/helpers'

type Props = {
  begin_date?: string
  expected_date?: string
  end_date?: string
}

const TaskByUserDatesCell = ({begin_date, expected_date, end_date}: Props) => {
  const daysOverdue = calculateDaysOverdue(expected_date, end_date)
  const isOverdue = daysOverdue > 0 && !end_date

  // Se não tiver nenhuma data, não exibe nada
  if (!begin_date && !expected_date) {
    return <div className='text-center'>-</div>
  }

  return (
    <div className='d-flex flex-column align-items-center gap-1'>
      {/* Dias em atraso - Badge vermelho se estiver atrasado */}
      {isOverdue && expected_date && (
        <div className='badge badge-danger d-inline-flex align-items-center justify-content-center px-2 py-1 mb-1'>
          <span className='fw-bold text-white fs-7'>
            {daysOverdue} {daysOverdue === 1 ? 'dia atrasado' : 'dias atrasados'}
          </span>
        </div>
      )}

      {/* Data esperada - se não estiver em atraso */}
      {!isOverdue && expected_date && (
        <span className='text-gray-600 fs-7'>{formatDaysAgo(expected_date)}</span>
      )}

      {/* Datas de início e fim */}
      {(begin_date || expected_date) && (
        <div className='d-flex flex-column align-items-start gap-1 mt-1'>
          {begin_date && (
            <span className='text-gray-500 fs-8'>
              Início: {formatDateToBrazilian(begin_date)}
            </span>
          )}
          {expected_date && (
            <span className='text-gray-500 fs-8'>
              Fim: {formatDateToBrazilian(expected_date)}
            </span>
          )}
        </div>
      )}
    </div>
  )
}

export {TaskByUserDatesCell}

